import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const STORE_NAME = "MASTER_STORE";
const INIT_STATE = {
  master: [],
};

const store = (set) => ({
  ...INIT_STATE,
  setMaster: async (master) => set(() => ({ master })),
});

export const masterStore = create(
  //devtools(store, { name: STORE_NAME })
  devtools(persist(store, { name: STORE_NAME }), { name: STORE_NAME })
);